export function buildGridItems({ root, countermeasures }) {
  const sectorTitleImgById = {
    advertising: 'images/_0001_advertising-title.jpg',
    education: 'images/_0003_education-title.jpg',
    social: 'images/_0005_social-title.jpg',
    creator: 'images/_0007_creator-title.jpg',
    infrastructure: 'images/_0009_infrastructure-title.jpg',
    ai: 'images/_0011_ai-title.jpg',
    fashion: 'images/_0013_fashion-title.jpg',
    live: 'images/_0015_live-title.jpg',
    music: 'images/_0017_music-title.jpg',
    craft: 'images/_0019_craft-title.jpg',
    screen: 'images/_0021_screen-title.jpg',
    games: 'images/_0023_games-title.jpg'
  };

  const sectorKeyById = {
    screen: 'SCREEN',
    games: 'GAMES',
    music: 'MUSIC',
    live: 'LIVE',
    creator: 'CREATOR',
    social: 'SOCIAL',
    education: 'EDUCATION',
    craft: 'CRAFT',
    fashion: 'FASHION',
    advertising: 'ADVERTISING',
    ai: 'AI',
    infrastructure: 'INFRASTRUCTURE'
  };

  const sectorOrder = ['SCREEN', 'GAMES', 'MUSIC', 'FASHION', 'CREATOR', 'ADVERTISING', 'AI', 'LIVE', 'CRAFT', 'SOCIAL', 'EDUCATION', 'INFRASTRUCTURE'];

  const data = root || {};
  const sectorsData = data || { sectors: [] };
  const sectors = Array.isArray(sectorsData.sectors) ? sectorsData.sectors : [];

  const cmSlides = Array.isArray(countermeasures) ? countermeasures : [];
  const cmBySector = {};
  cmSlides.forEach((s) => {
    if (!s || !s.sector || s.sector === 'OBSOLETE.COM') return;
    if (!cmBySector[s.sector]) cmBySector[s.sector] = [];
    cmBySector[s.sector].push(s);
  });

  const enhanced = [];

  sectors.forEach((sectorInfo) => {
    const sectorId = sectorInfo && sectorInfo.id ? sectorInfo.id : '';
    const sectorKey = sectorKeyById[sectorId] || (sectorInfo && sectorInfo.name ? String(sectorInfo.name).toUpperCase() : sectorId);
    if (!sectorKey) return;

    const sectorDisplayName = sectorInfo && sectorInfo.name ? sectorInfo.name : sectorKey;

    const sectorColIndex = sectorOrder.indexOf(sectorKey);
    const sectorColNum = Math.max(0, sectorColIndex) + 1;
    const modelImg = `images/dmodel-${String(sectorColNum).padStart(2, '0')}.jpg`;
    const ctaImg = `images/dcta-${String(sectorColNum).padStart(2, '0')}.jpg`;

    const preds = Array.isArray(sectorInfo.predictions) ? sectorInfo.predictions.slice(0, 5) : [];
    const cmPreds = (cmBySector[sectorKey] || []).slice(0, 5);

    const landingIntro = sectorInfo && sectorInfo.landing && Array.isArray(sectorInfo.landing.intro) ? sectorInfo.landing.intro : [];
    const landingTagline = sectorInfo && sectorInfo.landing && sectorInfo.landing.tagline ? sectorInfo.landing.tagline : '';
    const landingStory = [landingTagline, ...landingIntro].filter(Boolean).join('\n\n');

    const titleImg = sectorTitleImgById[sectorId] || 'images/title.jpg';

    enhanced.push({
      sector: sectorKey,
      sectorId,
      sectorDisplayName,
      type: 'landing',
      title: sectorDisplayName,
      story: landingStory,
      logic: '',
      img: titleImg
    });

    const predictions = cmPreds.length > 0 ? cmPreds : preds;
    while (predictions.length < 5) {
      predictions.push({
        title: `${sectorDisplayName} — PLACEHOLDER`,
        story: '',
        logic: '',
        img: 'images/title.jpg'
      });
    }

    predictions.slice(0, 5).forEach((p, idx) => {
      const title = p && p.title ? p.title : `${sectorDisplayName} — PREDICTION ${idx + 1}`;
      const story = p && p.story ? p.story : p && p.body ? p.body : '';
      enhanced.push({
        sector: sectorKey,
        sectorId,
        sectorDisplayName,
        type: 'prediction',
        title,
        story,
        logic: p && p.logic ? p.logic : '',
        img: p && p.img ? p.img : p && p.image ? p.image : 'images/title.jpg',
        countermeasures: p && p.countermeasures ? p.countermeasures : null,
        mitigated_story: p && p.mitigated_story ? p.mitigated_story : null,
        signal_validation: p && p.signal_validation ? p.signal_validation : null,
        signal_strength: p && p.signal_strength ? p.signal_strength : null
      });
    });

    const modelPitch = sectorInfo && sectorInfo.model_pitch ? sectorInfo.model_pitch : {};
    const modelHeadline = modelPitch && modelPitch.headline ? modelPitch.headline : '';
    const modelBody = modelPitch && Array.isArray(modelPitch.body) ? modelPitch.body : [];
    const modelStory = [modelHeadline, ...modelBody].filter(Boolean).join('\n\n');

    enhanced.push({
      sector: sectorKey,
      sectorId,
      sectorDisplayName,
      type: 'model',
      title: 'THE MODEL',
      story: modelStory,
      logic: '',
      img: modelImg,
      img_placeholder: `images/model_${sectorId}.jpg`
    });

    const cta = sectorInfo && sectorInfo.cta ? sectorInfo.cta : {};

    const ctaStory = [
      cta && cta.intro ? cta.intro : '',
      '',
      cta && cta.report_description ? cta.report_description : '',
      '',
      cta && cta.consultation_description ? cta.consultation_description : '',
      '',
      cta && cta.closing ? cta.closing : ''
    ]
      .filter((v) => v !== null && v !== undefined)
      .join('\n');

    enhanced.push({
      sector: sectorKey,
      sectorId,
      sectorDisplayName,
      type: 'cta',
      title: cta && cta.title ? cta.title : 'NEXT STEPS',
      story: ctaStory,
      logic: '',
      img: ctaImg,
      cta
    });
  });

  return enhanced;
}
